export default __webpack_public_path__ + "static/media/image21.61a00db3.jpg";